// extracted by mini-css-extract-plugin
export default {"textLink":"NewAccount_textLink__ZKElm","small":"NewAccount_small__MYQab","socials":"NewAccount_socials__jWJu4"};